export enum QuotationsOrderCreateState {
    FORM,
    SUMMARIZE,
}